import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import qs from 'qs'

//设置全局的请求次数，请求的间隙
axios.defaults.retry = 0;
axios.defaults.retryDelay = 1000;
// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 10000 // request timeout
})
// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        if (config.type != 'json') {
            config.headers['content-type'] = 'application/x-www-form-urlencoded'
            config.data = qs.stringify(config.data)
        } else {
            config.headers['content-type'] = 'application/json'
        }
        return config
    },
    error => {
        // do something with request error
        Vue.$vux.toast.text(error, "center");
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        // console.log(response.data)
        const res = response.data

        // Vue.$vux.toast.text(res.desc, "center");
        
        // if the custom code is not 20000, it is judged as an error.
        if (res.code && res.code != 0) {
            if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
                // Vue.$vux.toast.text(res.desc, "center");
            }
            if (res.code == "-1000"){
                localStorage.removeItem("wxGzhTrolleyUserInfo");
                localStorage.removeItem("wxGzhTrolleyCode");
                window.location.href = process.env.VUE_APP_BASE_API +'#'+ localStorage.getItem('wxGzhTrolleyOldPath')
            }
            // return Promise.reject(new Error(res.desc || 'Error'))
            return Promise.reject(res)
        } else {
            return res
        }
    },
    error => {
        return Promise.reject({desc:'网络异常'});
        
        // if (error.response && error.response.status && error.response.status == "401") {
        //     // store.dispatch('user/logout').then(() => {
        //     //     location.reload()
        //     // })
        // }
        // // return Promise.reject(error)
        // var config = error.config;
        // // If config does not exist or the retry option is not set, reject
        // if (!config || !config.retry) return Promise.reject(error);

        // // Set the variable for keeping track of the retry count
        // config.__retryCount = config.__retryCount || 0;

        // // Check if we've maxed out the total number of retries
        // if (config.__retryCount >= config.retry) {
        //     // Reject with the error
        //     return Promise.reject(error);
        // }

        // // Increase the retry count
        // config.__retryCount += 1;

        // // Create new promise to handle exponential backoff
        // var backoff = new Promise(function (resolve) {
        //     setTimeout(function () {
        //         config.baseURL = ""
        //         resolve();
        //     }, config.retryDelay || 1);
        // });

        // // Return the promise in which recalls axios to retry the request
        // return backoff.then(function () {
        //     return service(config);
        // })
    }
)

export default service



// WEBPACK FOOTER //
// ./src/assets/js/request.js